module.exports = __webpack_public_path__ + "static/media/blue-circle-top.72090e0d.png";